{
  "overview": {
    "activities": "Overview of activities",
    "noDashboardData": "You have no data for the dashboard",
    "approvals": "Entries for approval",
    "text": "Overview of your agenda as of <strong>{{date}}</strong>",
    "welcome": "Welcome, ",
    "agendaOverview": "Agenda overview",
    "record": "Record",
    "newRecords": "New records",
    "unfilled": "Unfilled",
    "favoriteAgendas": "Favorite Agendas"
  },
  "comments": {
    "writeComment": "Write a comment"
  },
  "modules": {
    "title": "Your modules",
    "subTitle": "Star the agendas you want on your overview.",
    "subTitleMobile": "Open a module and star agendas to pin them to your overview.",
    "showAll": "show all",
    "childModules": "Child modules",
    "totalRecords": "Total records",
    "waitingForApproval": "Waiting for approval",
    "newest": "Newest",
    "shareRecordTitle": "Share record"
  },
  "delete": {
    "success": "The record was successfully deleted",
    "successMultiple": "{{count}} records were successfully deleted",
    "error": "An error occurred while deleting the record",
    "errorForbidden": "You do not have permission to delete this record",
    "errorMultiple": "An error occurred while deleting records. {{count}} out of {{total}} selected records were deleted",
    "dirtyTableCannotDelete": "You cannot delete records while the table is being edited. Please save or cancel your changes and try again.",
    "selectEntriesToDelete": "Please select records to delete first"
  },
  "detail": {
    "titleNew": "New record",
    "titleEdit": "Edit record",
    "share": {
      "title": "Users to share",
      "add": "Add",
      "sharedTitle": "People with whom the record is shared",
      "backToShare": "Back to sharing",
      "showOverview": "Show overview",
      "shareDateTime": "Date and time of sharing"
    },
    "file": {
      "copyLink": "Copy link",
      "attachmentsTitle": "Attachments",
      "filesCount_one": "{{count}} file",
      "filesCount_few": "{{count}} files",
      "filesCount_other": "{{count}} files",
      "maxFilesReached": "A maximum of {{max}} files can be uploaded",
      "onlySomeFilesUploaded": "Only {{uploaded}} out of {{total}} selected files were uploaded (maximum: {{max}})",
      "maxFilesPerUpload": "A maximum of {{maxFiles}} files can be uploaded at a time.",
      "fileTooLarge": "Maximum file size is {{max}} MB.",
      "uploadInProgress": "An upload is in progress. Wait until it finishes.",
      "loadFailed": "Failed to load attachments.",
      "uploadFailed": "Failed to upload file '{{fileName}}'.",
      "retry": "Retry",
      "preview": {
        "notSupported": "Preview is not supported",
        "failedToDisplay": "Failed to display document preview.",
        "noData": "File contains no data.",
        "readError": "Error reading file."
      }
    },
    "form": {
      "title": "Do you want to close the form?",
      "text": "You have unsaved changes in the form. If you close it, you will lose this data. Do you really want to close the form?",
      "noCreate": "Creating records is not allowed in this agenda"
    },
    "modal": {
      "changeBehaviorTitle": "Record has been modified",
      "saveNestedList": "Unsaved data in Nested Listing",
      "notifyUserToSave": "For proper form functionality, it is advisable to save the record again",
      "notifyUnsavedValues": "Form contains values that will not be saved",
      "saveRequired": "For proper form functionality, it is required to save the record again. The record will be saved"
    },
    "lock": {
      "lockedTitle": "Record is locked",
      "lockedMessage": "This record is currently being edited by {{name}}. The lock expires at {{expiresAt}}.",
      "viewRecord": "View record",
      "expiredTitle": "Edit lock expired",
      "expiringTitle": "Edit lock expires soon",
      "expiringMessage": "The record lock will expire soon. Do you want to continue editing?",
      "expiringCountdown": "The lock expires in {{countdown}}",
      "continueEditing": "Continue editing",
      "expiredMessage": "Your edit lock has expired due to inactivity. Unsaved changes are lost.",
      "ok": "OK",
      "activeIndicator": "You are editing this record",
      "conflictExpired": "Your edit lock expired. Please re-enter edit mode.",
      "editingBanner": "{{name}} is currently editing this record."
    },
    "deleteModal": {
      "title": "Delete Record",
      "titleMultiple": "Delete Records",
      "text": "Do you really want to delete this record? This action is irreversible.",
      "textMultiple": "Do you really want to delete {{count}} selected records? This action is irreversible."
    }
  },
  "contacts": {
    "title": "Distribution list",
    "table": {
      "export": "Export",
      "print": "Print",
      "filters": "Filters",
      "search": "Search"
    },
    "toast": {
      "groupUpdated": "Group was successfully updated",
      "groupShared": "Group was successfully shared",
      "groupCreated": "Group was successfully created",
      "groupDeleted": "Group was successfully deleted",
      "groupAccepted": "Group was successfully accepted"
    },
    "groups": {
      "_": "Groups",
      "title": "Groups",
      "create": "Create",
      "search": "Search in group",
      "groupName": {
        "label": "Name of the new group",
        "placeholder": "Enter group name"
      },
      "all": "All",
      "users": "Users",
      "usersToShare": "People to share",
      "accept": "Accept",
      "remove": "Remove",
      "decline": "Decline",
      "deleteConfirmTitle": "Are you sure you want to remove this group?",
      "deleteConfirmDescription": "This action is irreversible."
    },
    "contacts": {
      "person": "Person",
      "email": "Email",
      "phoneNumber": "Phone number",
      "organization": "Company / Job position"
    },
    "add": "Add",
    "update": "Update",
    "share": "Share"
  },
  "chat": {
    "assistantTitle": "Flowio assistant",
    "newChat": "New chat",
    "assistantLabel": "Assistant:",
    "youLabel": "You:",
    "modeLabel": "Mode ",
    "modeGuide": "Guide",
    "modeGuideDescription": "Helps you with general questions and navigation in the administration",
    "modeJson": "Templates",
    "modeJsonDescription": "Helps you generate JSON templates for easier administration",
    "thinkingAnalyzingDocs": "I'm thinking about your question",
    "thinking": "Assistant is thinking…",
    "inputPlaceholder": "Write a message…",
    "sendTitle": "Send",
    "sendingTitle": "Sending…",
    "maximizeTitle": "Maximize",
    "restoreTitle": "Restore size",
    "closeTitle": "Close",
    "aiDisclaimer": "AI assistant can make mistakes. Please verify important information.",
    "copyText": "Copy text",
    "copied": "Copied!",
    "history": "History",
    "chatHistory": "Chat History",
    "messages": "messages",
    "deleteHistory": "Delete history",
    "assistantIdMissing": "Assistant ID for mode \"{{mode}}\" is empty or not configured",
    "connectionError": "Unable to connect to the server."
  },
  "substitutes": {
    "validation": {
      "substitutionType": {
        "required": "Substitution type is required"
      },
      "substituteUser": {
        "required": "Substitute user is required"
      },
      "absentUser": {
        "required": "Absent user is required"
      },
      "dateFrom": {
        "required": "Start date is required",
        "future": "Start date must be in the future"
      },
      "dateTo": {
        "required": "End date is required",
        "future": "End date must be in the future",
        "afterDateFrom": "End date must be after start date",
        "mustBeNull": "End date must be empty for permanent substitutions"
      },
      "permanentSubstitution": {
        "onlyForSubstitution": "Permanent substitution is only available for substitution type"
      },
      "roles": {
        "required": "At least one role must be selected"
      }
    }
  },
  "agendaList": {
    "noData": "No records."
  },
  "notifications": {
    "action": {
      "title": "Pending tasks",
      "subTitle": "Overview of tasks requiring your attention.",
      "noData": "All tasks requiring your attention have now been successfully resolved!"
    },
    "info": {
      "title": "Unread information",
      "subTitle": "Overview of important information requiring your attention.",
      "noData": "All important information requiring your attention has now been successfully handled!"
    },
    "deleteAll": "Delete all",
    "deleteAllSuccess": "All informational notifications have been deleted.",
    "filter": {
      "active": "Showing records with notifications",
      "clear": "Clear notifications filter"
    },
    "table": {
      "agenda": "Agenda",
      "description": "Description",
      "module": "Module",
      "name": "Task name"
    }
  }
}
